import { QUESTION_TYPES } from '../constants';

export const getNumberOfQuestionsToCharge = surveyLists => {
  const processedSurveyLists =
    surveyLists &&
    surveyLists.filter(
      q =>
        q.type !== QUESTION_TYPES.DISTRIBUTOR &&
        (!q.profiling || !q.profiling.isProfilingQuestion) &&
        q.type !== QUESTION_TYPES.MATRIX
    );
  const lengthOfInitialProcessedSurveyLists = processedSurveyLists.length;

  const matrixQuestions =
    surveyLists && surveyLists.filter(q => q.type === QUESTION_TYPES.MATRIX);
  const matchingMatrixRows = matrixQuestions.reduce((acc, q) => {
    const matrixRows =
      q.choices &&
      q.choices.filter(
        c =>
          q.matrix && q.matrix.decisionFrameworkType === c.decisionFrameworkType
      );
    return acc + (matrixRows ? matrixRows.length : 0);
  }, 0);

  return lengthOfInitialProcessedSurveyLists + 2 * (matchingMatrixRows || 0);
};

export const getSurveyQuestionsChargeAmount = (
  numberOfSurveyQuestions,
  questionsIncludedInLicence,
  defaultPermissionValues
) => {
  const baseCharge =
    numberOfSurveyQuestions <=
    defaultPermissionValues.QUESTIONS_PERMISSION_BASE_CHARGE_TRESHOLD
      ? defaultPermissionValues.QUESTIONS_PERMISSION_BASE_CHARGE_1
      : defaultPermissionValues.QUESTIONS_PERMISSION_BASE_CHARGE_2;
  const numberOfBatchesWithFiveAboveLicence =
    numberOfSurveyQuestions - questionsIncludedInLicence;

  let additionalCredits = 0;
  if (numberOfBatchesWithFiveAboveLicence > 0) {
    const numberOfBatches = Math.ceil(
      numberOfBatchesWithFiveAboveLicence /
        defaultPermissionValues.QUESTIONS_PERMISSION_ABOVE_EXTRA_CHARGE_BUCKET
    );

    let internalQuestionsCounter = questionsIncludedInLicence;
    let leftToInclude = numberOfBatchesWithFiveAboveLicence;
    if (numberOfBatches) {
      Array.from(Array(numberOfBatches).keys()).forEach(() => {
        let stepIncrement =
          defaultPermissionValues.QUESTIONS_PERMISSION_ABOVE_EXTRA_CHARGE_BUCKET;

        if (
          leftToInclude <
          defaultPermissionValues.QUESTIONS_PERMISSION_ABOVE_EXTRA_CHARGE_BUCKET
        ) {
          stepIncrement = leftToInclude;
        }

        leftToInclude -= stepIncrement;
        internalQuestionsCounter += stepIncrement;

        if (
          internalQuestionsCounter >
          defaultPermissionValues.QUESTIONS_PERMISSION_ABOVE_EXTRA_TRESHOLD
        ) {
          additionalCredits +=
            defaultPermissionValues.QUESTIONS_PERMISSION_ABOVE_EXTRA_CHARGE_2;
        } else {
          additionalCredits +=
            defaultPermissionValues.QUESTIONS_PERMISSION_ABOVE_EXTRA_CHARGE_1;
        }
      });
    }
  }

  return {
    baseCharge,
    additionalCredits,
    total: baseCharge + additionalCredits
  };
};

export const getSampleSizeChargeAmount = (
  sampleSize,
  sampleSizeIncludedInLicence,
  defaultPermissionValues
) => {
  if (defaultPermissionValues) {
    const sampleSizeAboveLicence =
      sampleSize > sampleSizeIncludedInLicence
        ? sampleSize - sampleSizeIncludedInLicence
        : 0;

    let additionalCredits = 0;
    if (sampleSizeAboveLicence > 0 && sampleSizeIncludedInLicence !== null) {
      const numberOfBatches = Math.ceil(
        sampleSizeAboveLicence /
          defaultPermissionValues.SAMPLE_SIZE_PERMISSION_BUCKET
      );

      if (numberOfBatches > 0) {
        additionalCredits =
          numberOfBatches *
          defaultPermissionValues.SAMPLE_SIZE_PERMISSION_CHARGE;
      }
    }

    const baseCharge = 0;
    return {
      baseCharge,
      additionalCredits,
      total: baseCharge + additionalCredits
    };
  }
  return null;
};
